import React from 'react';
import { Link } from 'react-router-dom';

import SiteSlider from 'Components/Slider/SiteSlider';
import FluidImg from 'Components/Media/Image/FluidImg';

import 'Components/Card/HitCardPopup/HitCardPopupScreenshotCarousel.scss';

// The carousel spans the full width of the popup, so every breakpoint takes the popup's width.
export const makeSliderSettings = (popupWidth) => {
  const base = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    sliderGap: 0,
    sliderWidth: popupWidth,
  };
  return { md: base, lg: base, xl: base, xxl: base };
};

const HitCardPopupScreenshotCarousel = ({
  screenshots: screenshotsProp = [],
  linkPath = '',
  linkFunc = () => { },
  popupWidth = 400,
}) => {
  if (screenshotsProp?.length === 0) return false;

  const screenshots = screenshotsProp.slice(0, 6);

  const sliderSettings = makeSliderSettings(popupWidth);

  return (
    <div className="HitcardPopupScreenshotCarousel">
      <SiteSlider
        fullWidth
        preloadSlides
        sliderSettings={sliderSettings}
        sliderClass="HitcardPopupScreenshotCarousel__slider"
      >
        {screenshots.map(cover => (
          <div className="HitcardPopupScreenshotCarousel__screenshot faux-block-link responsive-image responsive-image--16by9" key={cover}>
            <Link to={linkPath} className="faux-block-link__overlay-link" onClick={linkFunc} />
            {/* Portrait screenshots don't fill the 16:9 frame, so a blurred copy fills the gaps rather than cropping the image */}
            <FluidImg src={cover} sizesOverride="150px" className="HitcardPopupScreenshotCarousel__screenshot__background" />
            <FluidImg src={cover} alt={cover} className="HitcardPopupScreenshotCarousel__screenshot__foreground" />
          </div>
        ))}
      </SiteSlider>
    </div>
  );
};

export default HitCardPopupScreenshotCarousel;

